// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.
if (window.init_web_sms_channel){
  const channels = require.context('.', true, /_channel\.js$/)
  channels.keys().forEach(channels)
}